
function showReadMoreButton() {
    let captionBlocks = document.querySelectorAll('.snippet-caption')
    captionBlocks.forEach(caption => {
        let itemId = caption.dataset.itemId

        let captionContainer = document.querySelector('span.snippet-caption-span.item-'+itemId)
        let readMoreButton = document.querySelector('.read-more-btn.item-'+itemId)

        if (captionContainer && checkOverflow(captionContainer)) {
            readMoreButton.classList.remove('d-none')
        } else if (readMoreButton) {
            readMoreButton.classList.add('d-none')
        }
    });
}

function checkOverflow(elem) {
    const elemHeight = elem.getBoundingClientRect().height
    const parentHeight = elem.parentElement.getBoundingClientRect().height
    return elemHeight > parentHeight
}

export { showReadMoreButton, checkOverflow }
